import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import { ImageLink } from "../../../utils/constants";
import { getFetchData, submitForm } from "../../../utils/apiUtils";
import Breadcrumb from "../../../helper/Breadcrumb";
import Loader from "../../../Components/Loader";
import Upload from "../../../Components/upload";
import { SwitchToggle } from "../../../helper/ImageFormat";

const AddCategory = () => {
 const navigator = useNavigate();
 const location = useLocation();
 const editData = location.state;
 const [loading, setLoading] = useState(false);
 const [btnloading, setBtnLoading] = useState(false);
 const [categoryData, setCategoryData] = useState([]);
 const [errors, setErrors] = useState({
  name: "",
  title: "",
 });
 const [data, setData] = useState({
  name: "",
  title: "",
  parent_id: editData?.parent_id || "",
  image: null,
  isActive: editData?.isActive ?? true,
  position: editData?.position || editData?.nextPosition,
  sizeChart: null,
 });

 useEffect(() => {
  fetchCategoryData();
 }, []);

 const getCategoryById = async (id) => {
  if (!id) return;
  setLoading(true);
  try {
   const response = await axiosInstance.get(`/category/${id}`);
   if (response.status === 200) {
    const { data } = response.data;
    setData({
     name: data?.name || "",
     title: data?.title || "",
     parent_id: data?.parent_id || "",
     image: data?.image || null,
     isActive: data?.isActive ?? true,
     position: data?.position || 1,
     sizeChart: data?.sizeChart || null,
    });
   }
  } catch (error) {
   const err = error?.response?.data?.message;
   toast.error(err);
   return err;
  } finally {
   setLoading(false);
  }
 };

 useEffect(() => {
  if (editData?.id) {
   getCategoryById(editData?.id);
  }
 }, [editData]);

 const fetchCategoryData = async () => {
  await getFetchData({
   url: `/category`,
   setGetData: setCategoryData,
  });
 };

 if (loading) {
  return <Loader />;
 }

 const handleChange = (e) => {
  const { name, checked, value } = e.target;
  if (name === "isActive" || name === "mixed" || name === "isFilter") {
   setData({ ...data, [name]: checked });
  } else {
   setData({ ...data, [name]: value });
  }
  setErrors({ ...errors, [name]: "" });
 };
 const handleSubmit = async (e) => {
  e.preventDefault();
  setBtnLoading(true);
  try {
   if (!data.url || data.url.trim() === "") {
    delete data.url;
   }
   await submitForm({
    data,
    url: "/category",
    editingId: editData ? editData?.id : null,
    validateFields: [{ name: "name", message: "Name is required" }],
    validationErrorsSetter: setErrors,
    navigate: () => navigator(-1),
   });
  } catch (err) {
 return err
  } finally {
   setBtnLoading(false);
  }
 };

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Add category", path: "/add-category" },
 ];

 return (
  <>
   <div className="content-wrapper">
    <div className="page-header mt-4">
     <h3 className="page-title"> {editData?.id ? "Update" : "Add"} Category</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>
    <div className="row grid-margin stretch-card">
     <div className="col-md-12">
      <div className="card">
       <div className="card-body">
        <form className="pt-0" onSubmit={handleSubmit}>
         <div className="rounded border-secondary">
          <div className="mb-2 ">
           <div className="row mx-0 g-5">

              <div className="col-sm-6">
             <div className="form-group">
              <label
               htmlFor="exampleInputUsername2"
               className="col-form-label "
              >
               Sort Order
              </label>
              <input
               type="number"
               className={`border border-dark form-control form-control-sm ${errors.position ? "is-invalid" : ""}`}
               id="position"
               name="position"
               placeholder="Enter sort order"
               value={data.position}
               onChange={handleChange}
              />
              {errors.position && (
               <small className="text-danger">{errors.position}</small>
              )}
             </div>
            </div>


            <div className="col-sm-6">
             <div className="form-group">
              <label
               htmlFor="exampleInputUsername2"
               className="col-form-label "
              >
               Parent Category
              </label>

              <select
               className="form-control form-control-sm shadow-sm"
               id="parent_id"
               name="parent_id"
               value={data.parent_id}
               onChange={handleChange}
              >
               <option value="">Root</option>
               {categoryData &&
                categoryData.length > 0 &&
                categoryData.map((item, index) => (
                 <option key={index} value={item?.id}>
                  {item?.name}
                 </option>
                ))}
              </select>
             </div>
            </div>

            <div className="col-sm-6">
             <div className="form-group">
              <label
               htmlFor="exampleInputUsername2"
               className="col-form-label "
              >
               Name
              </label>

              <input
               type="text"
               className="form-control form-control-sm shadow-sm  border border-dark"
               id="name"
               name="name"
               placeholder="Enter name"
               value={data.name}
               onChange={handleChange}
              />
              {errors.name && <p className="text-danger">{errors.name}</p>}
             </div>
            </div>

            <div className="col-sm-6">
             <div className="form-group">
              <label
               htmlFor="exampleInputUsername2"
               className="col-form-label "
              >
               Title
              </label>

              <input
               type="text"
               className="form-control form-control-sm shadow-sm  border border-dark"
               id="name"
               name="title"
               placeholder="Enter title"
               value={data.title}
               onChange={handleChange}
              />
              {errors.title && <p className="text-danger">{errors.title}</p>}
             </div>
            </div>

         

            <div className="col-sm-6">
             <div className="form-group">
              <label htmlFor="desktopImage" className="col-form-label ">
               Image Size (375x375)
              </label>

              <Upload
               label="category-image"
               initialImage={data.image}
               onChange={(imgUrl) =>
                setData((prev) => ({
                 ...prev,
                 image: imgUrl,
                }))
               }
               apiUrl={"uploads?label=category"}
              />
             </div>
            </div>

            <div className="col-sm-6">
             <div className="form-group">
              <label htmlFor="desktopImage" className="col-form-label ">
               Size chart
              </label>

              <Upload
               label="Size chart"
               initialImage={data.sizeChart}
               onChange={(imgUrl) =>
                setData((prev) => ({
                 ...prev,
                 sizeChart: imgUrl,
                }))
               }
               apiUrl={"uploads?label=sizechart"}
              />
             </div>
            </div>

            <div className="col-md-12 mt-4 p-2">
             <SwitchToggle
              checked={data.isActive}
              onChange={(val) =>
               setData((prev) => ({ ...prev, isActive: val }))
              }
             />
            </div>
            <div
             className="d-flex justify-content-center align-items-center mt-4"
             style={{
              width: "100%",
              flexDirection: "row",
             }}
            >
             <button
              type="submit"
              className="btn btn-primary"
              disabled={btnloading}
             >
              {btnloading ? (
               <>
                <span
                 className="spinner-border spinner-border-sm me-2"
                 role="status"
                 aria-hidden="true"
                />
                Loading
               </>
              ) : editData?.id ? (
               "Update"
              ) : (
               "Add"
              )}
             </button>

             <Link to="/category">
              <button className="btn btn-danger ml-3">Cancel</button>
             </Link>
            </div>
           </div>
          </div>
         </div>
        </form>
       </div>
      </div>
     </div>
     <div className="col-md-4 stretch-card">
      <div className="card">
       {Array.isArray(data.file) && (
        <div className="border w-100 h-80 text-center mb-4">
         <h6 className="mt-3">Upload Brochure Preview</h6>
         {data.file.map((file, index) => (
          <div key={index} className="d-inline-block m-3">
           <Link
            to={
             file instanceof File ? URL.createObjectURL(file) : ImageLink(file)
            }
            target="_blank"
           >
            <img
             src="images/icon/pdf.png"
             alt="pdf_preview"
             className="ms-3 me-3 mb-3"
             width={60}
            />
           </Link>
          </div>
         ))}
        </div>
       )}
      </div>
     </div>
    </div>
   </div>
  </>
 );
};

export default AddCategory;
